import { Controller } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { IFormField } from "../../../models/app";


interface Props extends IFormField {
  errors: any;
  control: any;
  required?: boolean;
  defaultValue?: any;
  setValue?: any;
  errorMessage?: string;
  watch?: any;
}

const RHTextField: React.FC<Props> = ({
  label,
  name,
  type,
  placeholder,
  disabled,
  autoFocus,
  control,
  errors,
  required,
  defaultValue,
  onChange,
  setValue,
  hidden,
  isHorizontal,
  errorMessage,
  maxLength,
  internalLabel = false,
  watch,
}) => {
  const value = watch(name);
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <Grid container alignItems={"center"} hidden={hidden} width={"100%"}>
          {!internalLabel && (
            <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 2) : 12}>
              {label && (
                <Typography
                  variant="body2"
                  fontWeight={700}
                  textAlign={"start"}
                  minWidth={"16ch"}
                >
                  {label}
                </Typography>
              )}
            </Grid>
          )}
          <Grid item xs={12} md={label ? (!isHorizontal ? 12 : 10) : 12}>
            <TextField
              fullWidth
              size="small"
              {...field}
              required={required}
              type={type}
              label={internalLabel ? label : ""}
              disabled={disabled}
              autoFocus={autoFocus}
              // handle max length
              inputProps={{ maxLength: maxLength || 255 }}
              placeholder={placeholder}
              error={!!errors[name]}
              onChange={(e) => {
                onChange && onChange(e.target.value);
                setValue && setValue(name, e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
                children: label,
                sx: {
                  fontSize: "18px",
                  "& .MuiInputLabel-asterisk": {
                    color: required && !value ? "red" : "text.main",
                    fontSize: "24px",
                  },
                },
              }}
              helperText={errors[name] && `${errors[name].message}`}
              sx={{
                borderRadius: 3,
                "& .MuiOutlinedInput-root": {
                  bgcolor: "common.white",
                  "& fieldset": {
                    borderColor: "grey.500",
                  },
                  borderRadius: 3,
                },
              }}
              multiline={type === "textarea"}
              rows={type === "textarea" ? 5 : undefined}
            />
          </Grid>
          <Grid item xs={12}>
            {errorMessage && (
              <Typography
                variant="caption"
                color="error.main"
                textAlign={"start"}
              >
                {errorMessage}
              </Typography>
            )}
          </Grid>
        </Grid>
      )}
    />
  );
};

export default RHTextField;
